import { IQuestion } from '../../../types/ApiTypes';
import { QuestionTypes } from '../../../types/GlobalTypes';

export const individualGameQuestionTypes = [QuestionTypes.CLOSED, QuestionTypes.OPEN_SHORT_TEXT];

export const getIndividualGamePossibleQuestions = (questions: IQuestion[]) => {
  return questions.filter(question => individualGameQuestionTypes.includes(question.questionType.code));
};
